import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-white" data-id="element-105">
      <div className="max-w-3xl mx-auto px-4" data-id="element-106">
        <div className="bg-emerald-900 rounded-3xl p-8 md:p-12 text-center text-white relative overflow-hidden shadow-2xl" data-id="element-107">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-108"></div>

          <div className="relative z-10" data-id="element-109">
            <ShieldCheck className="w-20 h-20 text-emerald-400 mx-auto mb-6" data-id="element-110" />

            <h2 className="text-3xl md:text-4xl font-extrabold mb-6" data-id="element-111">
              Garantía 7 días sin preguntas
            </h2>

            <p className="text-lg md:text-xl text-emerald-100 mb-8 leading-relaxed" data-id="element-112">
              Abrí los 12 Tomos. Revisá los 6 Bonus. Usá los Ebooks Élite en tu
              clase.
              <br data-id="element-113" />
              <br data-id="element-114" />
              Si no es lo que esperabas →{' '}
              <strong className="text-white" data-id="element-115">100% de devolución.</strong> Sin
              preguntas. Sin formularios. Sin drama.
            </p>

            <div className="inline-block bg-emerald-800/50 border border-emerald-700 rounded-full px-6 py-2 text-sm font-bold text-emerald-300" data-id="element-116">
              TASA DE DEVOLUCIONES MENOR AL 2%
            </div>
          </div>
        </div>
      </div>
    </section>;
}